// Create a new file Footer.js in your components directory
import React from 'react';

const Footer = () => {
    return (
        <div className="w-full backdrop-blur-md bg-gradient-to-r from-white/80 via-white/85 to-white/80 border-t border-gray-100/50 shadow-lg shadow-gray-200/20 mt-auto">
            <div className="max-w-7xl mx-auto py-4 px-6">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-center">
                    <p className="text-sm text-gray-600 font-medium">
                        Crafted with{" "}
                        <span className="inline-block animate-pulse text-red-500 mx-1">❤️</span>
                        <by>{" "}</by>
                        <a
                          href="https://www.celerbay.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-bold text-transparent bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text hover:from-blue-700 hover:to-purple-700 transition-all duration-300 hover:scale-105 inline-block"
                        >
                          CelerBay
                        </a>
                        <span className="hidden sm:inline text-gray-400 text-sm font-medium">{" "} • {" "}</span>
                        <span className="hidden sm:inline text-gray-600 text-sm font-medium">Powering modern auto shops</span>
                    </p>
                    {/*<span className="hidden sm:inline text-gray-400 text-sm">•</span>*/}
                    {/*<p className="text-sm text-gray-500">*/}
                    {/*    Powering modern auto shops*/}
                    {/*</p>*/}
                </div>
            </div>
        </div>

    );
};

export default Footer;